import { render, staticRenderFns } from "./ItemTblDashboardComponent.vue?vue&type=template&id=4bf10fe8"
import script from "./ItemTblDashboardComponent.vue?vue&type=script&lang=js"
export * from "./ItemTblDashboardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf10fe8')) {
      api.createRecord('4bf10fe8', component.options)
    } else {
      api.reload('4bf10fe8', component.options)
    }
    module.hot.accept("./ItemTblDashboardComponent.vue?vue&type=template&id=4bf10fe8", function () {
      api.rerender('4bf10fe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/principal_search/components/ItemTblDashboardComponent.vue"
export default component.exports